<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CModal
        title="Test has been closed."
        centered
        color="light"
        :show.sync="adminLockTestModal"
        :closeOnBackdrop="false"
      >
        <h5>Contact the instructor of your section and try again later.</h5>
        <br />
      </CModal>
      <CModal
        title="Post-test has been closed."
        centered
        color="light"
        :show.sync="adminLockPostTestModal"
        :closeOnBackdrop="false"
      >
        <h5>{{ detail_posttest }}</h5>
        <br />
      </CModal>
      <CModal
        :title="this.lang === 'TH' ? 'ข้อควรทราบ' : 'Important Notice'"
        centered
        color="warning"
        :show.sync="warningTestModal"
        :closeOnBackdrop="false"
      >
        <h5>
          {{
            this.lang === 'TH'
              ? 'แบบทดสอบนี้สามารถทำได้เพียงครั้งเดียว กรุณาทำให้เสร็จจนจบหากออกจากระบบหรือหลุดระหว่างทำ คะแนนจะไม่ถูกบันทึก'
              : ' This test can be taken only once. Please complete it in one session. If you leave or are logged out before finishing, your score will not be saved.'
          }}
        </h5>
        <!-- <br /> -->
        <template slot="footer">
          <div class="d-flex justify-content-end gap-2">
            <CButton color="secondary" @click="warningTestModal = false">
              Cancel
            </CButton>
            <CButton color="success" class="ml-2" @click="proceedToPostTest">
              OK
            </CButton>
          </div>
        </template>
      </CModal>
      <full-page
        :options="options"
        id="fulp"
        ref="fullpage"
        v-if="v3FetchProgress"
      >
        <div class="section">
          <div class="body-slide">
            <SwiperItem
              :items="content"
              :lang="lang"
              :subProgress="subProgress"
              @nextRoute="nextRoute"
              :allContent="allContent"
              :lessonActive="lessonActive"
            />
          </div>
        </div>
        <div class="section text-center">
          <div class="body-slide">
            <List
              :items="content"
              :lang="lang"
              @nextRoute="nextRouteList"
              :allContent="allContent"
            />
          </div>
        </div>
      </full-page>
    </template>
  </div>
</template>

<script>
import FullPage from 'vue-fullpage.js/src/FullPage.vue';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import SwiperItem from './components/SwiperItem.vue';
import List from './components/List.vue';
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';

export default {
  name: 'LS01',
  components: {FullPage, Swiper, SwiperSlide, SwiperItem, List, LoadingMDL},
  data() {
    return {
      options: {
        navigation: true,
        navigationPosition: 'right',
        sectionsColor: ['#E6EFFF', '#E6EFFF'],
      },
      loading: true,
      currentRoute: '',
      content: [],
      lang: '',
      allContent: [],
      lessonActive: null,
      adminLockTestModal: false,
      adminLockPostTestModal: false,
      detail_posttest: '',
      code: '',
      section: '',
      menuCHN2: [],
      subProgress: [],
      v3Progress: [],
      v3FetchProgress: null,
      v3SubProgress: [],
      v3isLearned: false,
      v3Data: {},
      warningTestModal: false,
      postCodeItem: null,
    };
  },
  methods: {
    async onLoadData() {
      // console.log('onLoadData Begin');

      this.loading = true;

      this.lang = this.$store.getters['language/getLanguage'];
      this.lessonActive = this.$store.getters['necessary/getLessonActive'];
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      // this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.courseData = this.$store.state.necessary.learningCourse;
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);

      this.$store.dispatch('v3/v3LessonLock', {
        courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
        section: this.$store.state.v3.v3EnrollData.data.section,
      });
    },

    nextRoute: function (path) {
      this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage
      if (path != '' && typeof path != 'object') {
        let str = path.split('-');

        const nextPath = `/v4/${str[0]}/${str[1]}`;
        this.$store.commit('v3/stampMainCodeItem', path);
        this.$store.commit('v3/v3IsLearnOn');
        this.$store.commit('v3/v3IsUpdateProgressOn'); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
        this.$router.push(nextPath); // เปลี่ยนหน้า
      } else if (typeof path == 'object') {
        if (path.lock) {
          this.adminLockTestModal = true;
        } else {
          let str = path.path.split('-');

          const nextPath = `/v4/${str[0]}/${str[1]}`;
          // this.$router.push(body);
          this.$store.commit('v3/stampMainCodeItem', path.path); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
          this.$store.commit('v3/v3IsLearnOn');
          this.$store.commit('v3/v3IsUpdateProgressOn'); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
          this.$router.push(nextPath); // เปลี่ยนหน้า
          //
        }
      }
    },
    nextRouteList: function (path) {
      if (path != null) {
        if (parseInt(path) == 0) {
          //vocab list
          console.log(path);

          this.$router.push('/v4/LS04/1');
        } else if (parseInt(path) == 1) {
          //vdo list
          console.log(path);

          this.$router.push('/v4/CLP01/1');
        } else if (typeof path == 'object') {
          if (path.lock) {
            this.adminLockPostTestModal = true;
            this.detail_posttest = path.detail;
          } else if (path.lock == false) {
            //post test
            // console.log('post test on');
            //check here
            this.warningTestModal = true;
            this.postCodeItem = path.codeItem;
          } else {
            this.adminLockPostTestModal = true;
            this.detail_posttest = path.detail;
          }
        }
      }
    },
    v3ManageData: function (progress) {
      if (
        !progress ||
        !Array.isArray(progress.progress) ||
        !Array.isArray(progress.subProgress)
      )
        return;

      let preTest = null;
      const allChapters = [];
      const subProgress = [];

      const mainProgress = progress.progress;
      this.v3SubProgress = progress.subProgress;

      // then use this mix with progress
      const typeLesson = ['Start', 'Vocabulary', 'Assignment', 'Test'];
      for (let i = 0; i < this.menuCHN2.length; i++) {
        const chapter = this.menuCHN2[i];
        let mainChapter = null;
        let topics = [];
        let mainProgressNum = 0;
        let nextLock = false;

        if (mainProgress.length > 0) {
          // ใช้การ loop ข้อมูลแบบ paralle เนื่องจากข้อมูลมี structure เหมือนกันเเละจำนวนเท่ากัน
          mainChapter = mainProgress[i];
        }

        if (i >= 1 && i <= this.menuCHN2.length - 4) {
          // ไว้สำหรับแสดงตรง popup ของ result เพื่อดูโปรเกสเเละคะแนนของบทย่อย
          for (let l = 0; l < chapter.templateItem.length; l++) {
            const subChapter = chapter.templateItem[l];

            const sub = progress.subProgress.find(
              (p) => p.codeItem === subChapter
            ) || {
              progress: 0,
              score: 0,
            };

            const state = {
              type: typeLesson[l],
              order: l,
              progress: sub.progress,
              score: sub.score,
              topicCode: subChapter,
            };
            topics.push(state);
          } //loop3

          let refine = {
            chapter: chapter.codeItem,
            topics: topics,
          };

          subProgress.push(refine);
        }

        //log

        // เช็ค main progress ว่ามีข้อมูลของ progress ไหม
        if (mainChapter) {
          if (mainChapter.progress) {
            mainProgressNum = mainChapter.progress;
          }
        }

        let schema = {
          // สำหรับใช้แสดงข้มูลของโปรเกสหลักพร้อมกับเงื่อนไขเช็ค lock บท
          code: chapter.codeItem,
          progress: mainProgressNum,
          lock: false,
          number: i,
          type: chapter.type,
        };

        if (schema.progress < 70) {
          // i > 1 is chapter 2 until others chapter end
          if (mainProgress[i - 1]?.progress < 70) {
            nextLock = true;
          }
        }
        schema.lock = nextLock;

        allChapters.push(schema); // set default first
      }

      this.v3Progress = allChapters;
      this.subProgress = subProgress;
      this.v3FetchProgress = progress;

      this.allContent = {
        menuLock: this.v3Progress,
        checkPoints: progress.subProgress,
      };

      /////////////////////////////////////
      ////// PRETEST CHECK
      //check mainProgress type for pretest

      for (let j = 0; j < mainProgress.length; j++) {
        const progress = mainProgress[j];

        if (progress.type == 'pretest') {
          if (preTest == null) {
            preTest = progress;
          }
        }
      }

      if (preTest) {
        if (preTest.progress < 50) {
          // ทำตัว re-direct ไปที่หน้า CTT01-11

          const pretestStart = 'VAT01-11';
          const pathFormat = pretestStart.split('-');

          this.$store.commit('v3/v3PretestOn');
          this.$store.commit('v3/stampMainCodeItem', pretestStart);
          this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage

          this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
        } else {
          // console.log('pre test off');

          this.$store.commit('v3/v3PretestOff');
        }
      }

      // this.allContent = data;
      this.$store.commit('necessary/setMenuLockChinese2', this.v3Progress);
    },
    tryCallV3ManageData() {
      if (this.templateReady && this.progressReady && this.v3FetchProgress) {
        console.log('everythings ready');

        this.v3ManageData(this.v3FetchProgress);
      }
    },

    proceedToPostTest() {
      //stamp codeItem
      this.$store.commit('v3/stampMainCodeItem', this.postCodeItem);

      this.$router.push('/v4/CMD01/90');
    },
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',

      //v3
      getTemplatev3: 'v3/getTemplates',
      getCourseProgress: 'v3/getCourseProgress',

      //v4
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content.item;

      this.menuCHN2 = val.menuCHN2;
      this.templateReady = true;

      this.$store.dispatch('v3/fetchCourseProgress', {
        codeItem: this.currentRoute,
        courseId: this.$store.state.necessary.learningCourse,
        //courseId: this.$store.getters['necessary/getLerningCourse']._id
      });
    },

    storeLanguage: function (val) {
      this.lang = val;
    },

    getCourseProgress: function (val) {
      this.v3FetchProgress = val;
      this.progressReady = true;
      this.v3ManageData(val);
      //loading false after progress done
      this.loading = false;
    },

    saveContentStatusv4: function () {
      //get Progress after watch trigger
      // this.checkUpdateProgress();
      this.onLoadData();
    },
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    if (
      this.$store.state.v4.v4CurrentMainCodeItem &&
      this.$store.state.v4.v4DataStack.length !== 0
    ) {
      // console.log('pigeon run!');

      this.$store.dispatch('v4/forceSavePayload', {
        mainCodeItem: this.$store.state.v4.v4CurrentMainCodeItem,
        mainType: this.$store.state.v4.v4MainType,
        mainContent: this.$store.state.v4.v4MainContent,
        dataStack: this.$store.state.v4.v4DataStack,
        pages: this.$store.state.v4.v4Pages,
        courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
        section: this.$store.state.v3.v3EnrollData.data.section,
      });
    } else {
      this.onLoadData();
    }
  },
};
</script>

<style>
@import 'https://unpkg.com/fullpage.js/dist/fullpage.min.css';

* {
  user-select: none;
}

.modal-title {
  color: white;
}

.modal-light .modal-header {
  background-color: #808588;
}

.btn-light,
.btn-light:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary,
.btn-secondary:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.body-slide {
  display: flex;
  margin-top: 14%;
  width: 100%;
  justify-content: center;
}

#fp-nav ul,
.fp-slidesNav ul {
  margin: 0;
  padding: 0;
  display: flex;
  height: 80vh;
  flex-direction: column;
  justify-content: space-around;
  background-color: #89abe6;
  border-radius: 20px;
  width: 6px;
  align-items: center;
}

#fp-nav:hover ul li a span,
.fp-slidesNav ul li a span {
  margin: -2px 0 0 -2px;
  width: 15px;
  height: 15px;
}

#fp-nav ul li a.active span,
#fp-nav ul li:hover a.active span,
.fp-slidesNav ul li a.active span,
.fp-slidesNav ul li:hover a.active span {
  height: 20px;
  width: 20px;
  margin: -6px 0 0 -6px;
  border-radius: 100%;
  position: absolute;
  left: 30%;
  background-color: #1d5bd7;
}

#fp-nav ul li a span,
.fp-slidesNav ul li a span {
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  height: 15px;
  width: 15px;
  border: 0;
  background: #89abe6;
  left: 10%;
  /* top: 50%; */
  margin: -2px 0 0 -2px;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

@media only screen and (min-width: 300px) and (max-width: 1024px) {
  #fp-nav ul,
  .fp-slidesNav ul {
    margin: 0;
    padding: 0;
    display: flex;
    height: 5vh;
    flex-direction: column;
    border-radius: 20px;
    width: 0;
  }

  #fp-nav ul li a.active span,
  #fp-nav ul li:hover a.active span,
  .fp-slidesNav ul li a.active span,
  .fp-slidesNav ul li:hover a.active span {
    height: 12px;
    width: 12px;
    margin: -6px 0 0 -6px;
    border-radius: 100%;
    position: absolute;
    left: 10%;
    background-color: #1d5bd7;
  }

  #fp-nav ul li a span,
  .fp-slidesNav ul li a span {
    border-radius: 50%;
    position: absolute;
    z-index: 1;
    height: 10px;
    width: 10px;
    border: 0;
    background: #89abe6;
    left: -10%;
    top: 50%;
    margin: -2px 0 0 -2px;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }

  .card {
    border: 0;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
  }
}

@media only screen and (min-width: 1600px) {
  #fp-nav.fp-left {
    left: 17px;
    margin-left: 3%;
  }
}
</style>
